<div class="rejectionList">
  <div class="topHead">
    <span>Are you sure you want to reject this datum?</span>
  </div>

  <div class="optionList">
    <span>Please select one or more reasons</span>
    <hr />
    <div class="checkboxList">
      <div class="checkGrp d-flex align-center mb-2">
        <label class="custom-checkbox">
          <input
            type="checkbox"
            (change)="toggleSelection($event)"
            value="Member name & philanthropy name mismatch"
          />
          <span class="checkmark"></span>
        </label>
        <span [ngClass]="memName == true ? 'activeSpan' : ''"
          >Member name & philanthropy name mismatch</span
        >
      </div>
      <div class="checkGrp d-flex align-center mb-2">
        <label class="custom-checkbox">
          <input
            type="checkbox"
            (change)="toggleSelection($event)"
            value="Insufficient address details"
          />
          <span class="checkmark"></span>
        </label>
        <span [ngClass]="insuffAdd == true ? 'activeSpan' : ''"
          >Insufficient address details</span
        >
      </div>
      <div class="checkGrp d-flex align-center mb-2">
        <label class="custom-checkbox">
          <input
            type="checkbox"
            (change)="toggleSelection($event)"
            value="Wrong PIN code"
          />
          <span class="checkmark"></span>
        </label>
        <span [ngClass]="wPin == true ? 'activeSpan' : ''">Wrong PIN code</span>
      </div>
      <div class="checkGrp d-flex align-center mb-2">
        <label class="custom-checkbox">
          <input
            type="checkbox"
            (change)="toggleSelection($event)"
            value="Outdated last istavrity date"
          />
          <span class="checkmark"></span>
        </label>
        <span [ngClass]="wIVdate == true ? 'activeSpan' : ''"
          >Outdated last istavrity date</span
        >
      </div>
      <div class="checkGrp d-flex align-center mb-2">
        <label class="custom-checkbox">
          <input
            type="checkbox"
            (change)="toggleSelection($event)"
            value="Incorrect address"
          />
          <span class="checkmark"></span>
        </label>
        <span [ngClass]="wAddress == true ? 'activeSpan' : ''"
          >Incorrect address</span
        >
      </div>
      <div class="checkGrp d-flex align-center mb-2">
        <label class="custom-checkbox">
          <input
            type="checkbox"
            (change)="toggleSelection($event)"
            value="Incorrect email address"
          />
          <span class="checkmark"></span>
        </label>
        <span [ngClass]="wEmail == true ? 'activeSpan' : ''"
          >Incorrect email address</span
        >
      </div>
      <div class="checkGrp d-flex align-center mb-2">
        <label class="custom-checkbox">
          <input
            (change)="toggleSelection($event)"
            value="Others"
            type="checkbox"
          />
          <span class="checkmark"></span>
        </label>
        <span [ngClass]="othersClicked == true ? 'activeSpan' : ''"
          >Others</span
        >
      </div>
      <!-- <input type="checkbox" id="vehicle2" name="vehicle2" value="Car" />
      <label for="vehicle2"> I have a car</label><br />
      <input type="checkbox" id="vehicle3" name="vehicle3" value="Boat" />
      <label for="vehicle3"> I have a boat</label><br /><br /> -->
    </div>

    <form action="">
      <div class="commentSec">
        <textarea
          [formControl]="reasonForm"
          [readonly]="!enableCommentSec"
          class="search-input dp-input-control"
          name=""
          placeholder="Add Comment"
          id=""
        ></textarea>
      </div>
    </form>
  </div>

  <div class="actionBtn d-flex justify-content-between">
    <div
      class="reject cursor-pointer"
      [ngClass]="isLoaderSpin ? 'spinner' : ''"
      (click)="acceptRejection()"
    >
      <div class="cross"></div>
      <span>{{ rejectBTnText }}</span>
    </div>
    <div
    type="reset"
    class="dp-secondary-btn cancel"
    mat-button
    mat-dialog-close
  >
    <span> No, Cancel </span>
  </div>
  </div>
</div>
